import React,
{ Component } from 'react'
import { connect } from 'react-redux'

import { MenuButton } from '@driftt/dds'
import {
  ActionDropdown,
  Div 
} from '@driftt/tide-core'
import { tracking } from '@driftt/traffic-control'

import './style.css'

const mapStateToProps = state => ({ selectedMembers: state.__CRM.segmentList.selectedMembers })

class ManageSegmentList extends Component {
  getActions = () => {
    const {
      onShowDetails,
      onCsvExport,
      onDeleteSegment,
      onDeleteSelected,
      onDeleteAllContacts,
      selectedMembers,
      isSystemOwned
    } = this.props

    const defaultActions = [
      {
        label: 'Segment details',
        icon: 'eye',
        action: () => onShowDetails()
      },
      // {
      //   label: 'Export CSV of segment',
      //   icon: 'download-2',
      //   action: () => onExport()
      // },
      {
        label: 'Download CSV of segment',
        icon: 'download-2',
        action: () => onCsvExport()
      },
      {
        label: 'Delete all contacts in segment',
        icon: 'trash',
        action: () => onDeleteAllContacts()
      },
    ]

    if (!isSystemOwned) {
      defaultActions.push({
        label: 'Delete segment',
        icon: 'trash',
        action: () => onDeleteSegment()
      })
    }

    if (selectedMembers.length > 0) {
      defaultActions.push({
        label: 'Delete selected contacts',
        icon: 'trash',
        action: () => onDeleteSelected()
      })
    }


    return defaultActions
  }

  renderEnrollInSegmentAction = (segment, onTarget, isLoading) => {
    const {
      onAddSegmentToPlaybook,
      isCreatingFastlanePlaybook,
      onCreatePlaybook 
    } = this.props

    return (
      <Div className="single-segment--enroll-segment">
        <MenuButton buttonText='Add to playbook audience' loading={isCreatingFastlanePlaybook}
          options={[
            {
              name: 'Add to existing playbook',
              action: hideDropdown => {
                onAddSegmentToPlaybook()
                tracking.trackEvent('Contact Segments - Clicked Add To Playbook', { page: 'Single Segment' })

                hideDropdown()
              },
            },
            {
              name: 'Create a new playbook',
              action: hideDropdown => {
                onCreatePlaybook()
                tracking.trackEvent('Contact Segments - Clicked Create Fastlane Playbook', { page: 'Single Segment' })

                hideDropdown()
              },
            },
          ]}/>
      </Div>
    )
  }

  render() {
    return (
      <>
        {this.renderEnrollInSegmentAction()}
        <ActionDropdown 
          title="Manage members"
          align="right"
          buttonType="primary"
          className="single-segment--manage--dropdown"
          actions={this.getActions()}
        />
      </>
    )
  }
}

export default connect(mapStateToProps, null)(ManageSegmentList)
